import { forwardRef } from "react";

import { FileUploadDropzone } from "./FileUploadDropzone";
import { FileUploadLite } from "./FileUploadLite";
import { FileUploadProps } from "./types";
import { useFileUpload } from "./use-file-upload";
import { DEFAULT_MAX_FILE_SIZE_MB } from "./validation";

/**
 * Campo de upload de arquivo com validação por tipo (extensão, nomenclatura,
 * tamanho) e identidade visual própria. Toda a lógica vive em `useFileUpload`;
 * a renderização é delegada à variante escolhida (`lite` ou `default`).
 */
export const FileUpload = forwardRef<HTMLDivElement, FileUploadProps>(function FileUpload(
  {
    type,
    label,
    onFileChange,
    disabled,
    className,
    variant = "default",
    uniqueId,
    file = null,
    maxFileSizeMB = DEFAULT_MAX_FILE_SIZE_MB,
    required = false,
    accept,
    pasteSempreAtivo,
  },
  ref,
) {
  const state = useFileUpload({
    type,
    onFileChange,
    defaultFile: file,
    disabled,
    uniqueId,
    maxFileSizeMB,
    accept,
    pasteSempreAtivo,
  });

  const viewProps = { state, label, required, disabled, maxFileSizeMB, className };

  if (variant === "lite") {
    return <FileUploadLite ref={ref} {...viewProps} />;
  }

  return <FileUploadDropzone ref={ref} {...viewProps} />;
});
